import api from './api';
import { API_URLS, TIMEOUTS } from '../config/apiConfig';
import axios from 'axios';

/**
 * App Version API Service
 * Handles all CRUD operations for app version management
 */
export const appVersionAPI = {
  /**
   * Get all app versions with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.per_page - Items per page (default: 10)
   * @param {boolean} params.include_inactive - Include inactive versions
   * @returns {Promise} API response
   */
  getAppVersions: async (params = {}) => {
    const response = await api.get('/app-versions', { params });
    return response;
  },

  /**
   * Get app version by ID
   * @param {number} id - Version ID
   * @returns {Promise} API response
   */
  getAppVersion: async (id) => {
    const response = await api.get(`/app-versions/${id}`);
    return response;
  },

  /**
   * Create new app version
   * @param {Object} versionData - Version data
   * @returns {Promise} API response
   */
  createAppVersion: async (versionData) => {
    const response = await api.post('/app-versions', versionData);
    return response;
  },

  /**
   * Update existing app version
   * @param {number} id - Version ID
   * @param {Object} versionData - Updated version data
   * @returns {Promise} API response
   */
  updateAppVersion: async (id, versionData) => {
    const response = await api.put(`/app-versions/${id}`, versionData);
    return response;
  },

  /**
   * Delete app version (soft delete)
   * @param {number} id - Version ID
   * @returns {Promise} API response
   */
  deleteAppVersion: async (id) => {
    const response = await api.delete(`/app-versions/${id}`);
    return response;
  },

  /**
   * Activate app version (deactivates all others)
   * @param {number} id - Version ID
   * @returns {Promise} API response
   */
  activateAppVersion: async (id) => {
    const response = await api.post(`/app-versions/${id}/activate`);
    return response;
  },

  /**
   * Get public app version details (no authentication required)
   * @returns {Promise} API response
   */
  getPublicAppDetails: async () => {
    // Use backend base URL for website endpoints since this doesn't require admin authentication
    const response = await axios.get(`${API_URLS.BACKEND_BASE}/api/website/glammiy-app-details`, {
      timeout: TIMEOUTS.DEFAULT,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
}; 